import React from "react";
import { Search, Menu, Phone } from "lucide-react";
import ThemeToggle from "../../shared/components/ThemeToggle";

const DashboardHeader = ({
  searchTerm,
  setSearchTerm,
  handleSearchSubmit,
  openNewCaseModal,
  onNewAgent,
  onMenuClick,
  onOpenDialer,
}) => {
  return (
    <header className="h-16 border-b dark:border-slate-800 border-slate-200 flex items-center justify-between px-4 sm:px-6 dark:bg-slate-900/50 bg-white/80 backdrop-blur-sm relative z-50 transition-colors duration-300">
      <div className="flex items-center gap-3 flex-1">
        <button
          onClick={onMenuClick}
          className="md:hidden dark:text-slate-400 text-slate-600 hover:text-slate-900 dark:hover:text-white p-1 -ml-2 mr-2"
        >
          <Menu className="w-6 h-6" />
        </button>
        <form onSubmit={handleSearchSubmit} className="relative w-full max-w-md hidden sm:block">
          <Search className="w-4 h-4 dark:text-slate-500 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
          <input
            type="text"
            placeholder="Search borrowers or case numbers..."
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
            className="w-full dark:bg-slate-900 bg-slate-100 border dark:border-slate-700 border-slate-200 rounded-full pl-9 pr-3 py-1.5 text-sm dark:text-slate-300 text-slate-700 focus:border-sky-500 focus:outline-none transition-all duration-200 placeholder-slate-400"
          />
        </form>
        <button
          onClick={openNewCaseModal}
          className="px-3 py-1.5 bg-sky-600 text-white rounded-lg text-sm font-semibold hover:bg-sky-500 transition-colors sm:hidden"
        >
          New Case
        </button>
        <div className="flex items-center gap-3 sm:gap-4 ml-auto">
          {onOpenDialer && (
            <button
              onClick={onOpenDialer}
              className="p-2 rounded-lg dark:bg-slate-800 bg-slate-100 dark:hover:bg-slate-700 hover:bg-slate-200 dark:text-slate-400 text-slate-600 hover:text-green-500 dark:hover:text-green-400 transition-colors"
              title="Open Phone Dialer"
            >
              <Phone className="w-5 h-5" />
            </button>
          )}
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
